import { useEffect } from 'react';

const BASE = 'Hub · Buck Mason';

/** What the current screen asked for, and which environment this is; the title is built from both. */
let current: string | null | undefined;
let prefix = '';

const format = () => `${prefix}${current ? `${current} · Hub` : BASE}`;

/**
 * Set by App from GET /api/id/meta. "[dev]" in every tab title tells the two environments apart.
 * Re-applies the title at once: the answer usually arrives after the first screen's effect ran.
 */
export function setTitlePrefix(env: 'local' | 'dev' | 'production' | undefined) {
  const next = env === 'dev' ? '[dev] ' : '';
  if (next === prefix) return;
  prefix = next;
  document.title = format();
}

/** One document title per screen: "People · CX Hub", not the same string everywhere. */
export function useTitle(title: string | null | undefined) {
  useEffect(() => {
    current = title;
    document.title = format();
    return () => {
      current = undefined;
      document.title = format();
    };
  }, [title]);
}
